import axiosInstance from '../../config/axiosConfig';
import { urlDimensionValoracion } from '../../config/apiURL';
import { extractArray, extractDataObject } from '../utils/responseHelpers';

export async function getDimensionValoracion() {
    try {
        const response = await axiosInstance.get(urlDimensionValoracion);
        return extractArray(response);
    } catch (error) {
        console.error('Error fetching dimension valoracion:', error);
        throw error;
    }
}

// Obtener una dimensión de valoración por ID
export async function getDimensionValoracionById(id) {
    try {
        const response = await axiosInstance.get(`${urlDimensionValoracion}/${id}`);
        return extractDataObject(response);
    } catch (error) {
        console.error(`Error fetching dimension valoracion ${id}:`, error);
        throw error;
    }
}

export async function createDimensionValoracion(formulario) {
  try {
    const response = await axiosInstance.post(urlDimensionValoracion, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating dimension valoracion:', error);
    throw error;
  }
}

export async function updateDimensionValoracion(id, formulario) {
  try {
    const response = await axiosInstance.put(`${urlDimensionValoracion}/${id}`, formulario);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating dimension valoracion ${id}:`, error);
    throw error;
  }
}

export async function deleteDimensionValoracion(id) {
  try {
    const response = await axiosInstance.delete(`${urlDimensionValoracion}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting dimension valoracion ${id}:`, error);
    throw error;
  }
}